import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'cm-attachment-icon-button',
  template: `
    <button mat-icon-button
            color="{{active ? 'accent' : 'primary'}}"
            (click)="onClick($event)"
            matTooltip="Attachments">
      <!--<span *ngIf="numOfAttachments && numOfAttachments>0">{{numOfAttachments}}</span>-->
      <span matBadge="{{numOfAttachments}}" matBadgeColor="primary"
            matBadgePosition="above after"
            matBadgeOverlap="true" matBadgeSize="small"
            *ngIf="numOfAttachments && numOfAttachments>0">
            <i class="far fa-paperclip"></i>
      </span>
      <span class="far fa-paperclip" *ngIf="!numOfAttachments"></span>
      <!--<span class="d-md-none">Attachment</span>-->
    </button>
  `
})
export class AttachmentIconButtonComponent {

  @Output()
  public click: EventEmitter<any> = new EventEmitter();

  @Input()
  public active = false;

  @Input()
  public numOfAttachments;

  constructor() {
  }

  onClick(event) {
    event.stopPropagation();
    this.click.emit(event);
  }
}
